import ensureMonthIndexInRange from "./ensureMonthIndexInRange";


export default () => ensureMonthIndexInRange(new Date().getMonth() + 1);